import RadioButtonCheckedIcon from '@/assets/icons/radio-checked-icon.svg';
import { breakpoints } from '@/themes/themeOverrides/Breakpoints';
import { Palette } from '@/themes/themeOverrides/Palette';

export const globalStyles = {
    autocompleteParent: {
        position: 'relative',
        width: '100%',
        '& .MuiPaper-elevation': {
            boxShadow: `${Palette.boxShadow.elevation16} !important`,
        },
        '& .custom-select-array-input': {
            '& + .MuiAutocomplete-popper': {
                '&[data-popper-placement="bottom"]': {
                    top: '46px !important',
                },
                '&[data-popper-placement="top"], &[data-popper-placement="top-start"]': {
                    bottom: '110% !important',
                },
            },
        },
        '& .MuiAutocomplete-root.input-filled .MuiFormLabel-root': {
            transform: 'translate(14px, -11px) scale(1)',
        },
        '& .MuiFormControl-root.input-filled .MuiFormLabel-root': {
            transform: 'translate(14px, -11px) scale(1) !important',
        },
    },
    headerActionsWrapper: {
        [`@media (max-width: ${breakpoints.values.md}px)`]: {
            display: 'flex',
            gap: '8px',
            alignItems: 'inherit',
            marginBottom: '20px',
        },
        [`@media (max-width: ${breakpoints.values.sm}px)`]: {
            alignItems: 'flex-end',
        },
        '&.actions-wrapper--actions-right': {
            display: 'flex',
            alignItems: 'flex-end',
            '& .actions-wrapper__desktop': {
                display: 'none',
            },
            '& > .MuiToolbar-root': {
                display: 'contents',
            },
            '& .period-form': {
                order: 1,
                flexShrink: 0,
                '& .period-select': {
                    [`@media (max-width: ${breakpoints.values.sm}px)`]: {
                        minWidth: '120px',
                        maxWidth: '120px',
                    },
                },
            },
            '& .mobile-filter-button': {
                order: 2,
                flex: '1 1 auto',
                width: 'auto',
                minWidth: 0,
            },
            '& > .MuiToolbar-root > *:not(.search-form):not(.filter-button):not(.period-form)': {
                order: 3,
                flexShrink: 0,
            },
        },
        '& .actions-wrapper__desktop': {
            flex: 1,
            [`@media (max-width: ${breakpoints.values.md}px)`]: {
                flex: '0',
            },
            '&.actions-wrapper__desktop--ad': {
                flex: 'auto',
                width: '100%',
                '& .MuiToolbar-root .MuiButtonBase-root.MuiIconButton-root': {
                    [`@media (max-width: ${breakpoints.values.md}px)`]: {
                        display: 'flex',
                        position: 'absolute',
                        right: '0',
                        top: '-60px',
                    },
                },
                '& .period-form, & .status-form': {
                    width: '100%',
                },
                '& .period-select, & .status-select': {
                    width: '100%',
                    minWidth: '238px !important',
                },
            },
            '& .period-form': {
                '& .period-select': {
                    minWidth: '222px',
                    [`@media (max-width: ${breakpoints.values.sm}px)`]: {
                        minWidth: 'calc(100vw - 193px)',
                    },
                },
            },
            '& .MuiToolbar-root .MuiButtonBase-root.MuiIconButton-root': {
                [`@media (max-width: ${breakpoints.values.md}px)`]: {
                    display: 'none',
                },
            },
        },
        '& .filter-button': {
            position: 'relative',
            [`@media (max-width: ${breakpoints.values.md}px)`]: {
                display: 'none',
            },
            '&.active': {
                '& button': {
                    backgroundColor: Palette.white,
                    boxShadow: `inset 0 0 0 2px ${Palette.black} !important`,
                    outline: `2px solid ${Palette.yellow.yellow200} !important`,
                },
            },
            '& button': {
                color: 'transparent',
                paddingRight: '18px',
                outline: 'none !important',
                boxShadow: `${Palette.boxShadow.elevation1} !important`,
                '&:hover': {
                    backgroundColor: Palette.white,
                    boxShadow: `${Palette.boxShadow.elevation2} !important`,
                },
                '&:focus': {
                    boxShadow: 'none',
                    outline: 'none !important',
                },
                '&:active': {
                    boxShadow: 'none',
                    outline: 'none !important',
                },
            },
            '&::after': {
                content: 'attr(data-label)',
                display: 'inline-block',
                fontSize: '14px',
                fontWeight: '500',
                position: 'absolute',
                left: '42px',
                top: '11px',
                pointerEvents: 'none',
            },
        },
        '& .mobile-filter-button': {
            display: 'none',
            background: Palette.white,
            padding: '12px 16px',
            justifyContent: 'flex-start',
            lineHeight: '20px',
            whiteSpace: 'nowrap',
            '&:hover, &:active, &:focus, &.active': {
                backgroundColor: `${Palette.white} !important`,
                outline: `2px solid ${Palette.gray.gray900}`,
                outlineOffset: '-2px',
                boxShadow: `0 0 0 2px ${Palette.yellow.yellow200} !important`,
            },
            [`@media (max-width: ${breakpoints.values.md}px)`]: {
                display: 'flex',
                flex: '1',
            },
        },
    },
    mobileFilterActive: {
        '&.mobile-active': {
            visibility: 'visible',
            display: 'block',
            position: 'absolute',
            width: 'calc(100% - 40px)',
            marginTop: '-20px',
            backgroundColor: Palette.white,
            borderRadius: '20px',
            padding: '21px 24px 24px 24px',
            boxShadow: Palette.boxShadow.elevation16,
            margin: '-18px 0 0 0',
            zIndex: '4',
            maxWidth: '460px',
            right: '20px',
            '& .filter-field': {
                display: 'block',
                marginBottom: '19px',
                '& .RaFilterFormInput-spacer': {
                    display: 'none',
                },
                '& .MuiAutocomplete-root>.MuiFormControl-root::before': {
                    display: 'none',
                },
                '& .MuiAutocomplete-root>.MuiFormControl-root::after': {
                    display: 'none',
                },
                '& .checkboxes-filter .has-external-chips .reference-array-filter__chips::after': {
                    background: `linear-gradient(90deg, rgba(247, 247, 247, 0.00) 0%, ${Palette.white} 100%)`,
                },
                '& .MuiFormControl-root .MuiInputLabel-root': {
                    backgroundColor: Palette.white,
                },
                '&:not([data-source])': {
                    margin: '0',
                },
            },
            '& .filter-mobile-action': {
                display: 'none',
                [`@media (max-width: ${breakpoints.values.md}px)`]: {
                    display: 'block',
                    width: '100%',
                    padding: '5px 0 6px 0',
                    position: 'relative',
                    '& .MuiButton-root': {
                        padding: '12px',
                        borderRadius: '12px',
                    },
                },
            },
            '& form': {
                padding: '0',
                margin: '0',
                '& .filter-field': {
                    width: '100%',
                    minWidth: '100%',
                    display: 'block',
                    marginBottom: '24px',
                    '&[data-source="period"]': {
                        marginBottom: '0',
                        '& .range-picker': {
                            marginBottom: '24px',
                        },
                    },
                    '& .RaFilterFormInput-spacer': {
                        display: 'none',
                    },
                    '& .arrow-up-collapse-icon': {
                        zIndex: '5',
                    },
                    '& .rs-picker-daterange': {
                        width: '100%',
                        minWidth: '100%',
                        '& .rs-input-group-addon': {
                            position: 'absolute',
                            right: '9px',
                            top: '8px',
                        },
                    },
                    '& .MuiFormControl-root': {
                        width: '100%',
                        minWidth: '100%',
                        '& .MuiInputLabel-root': {
                            backgroundColor: Palette.white,
                            '&.MuiInputLabel-shrink, &.top': {
                                [`@media (max-width: ${breakpoints.values.md}px)`]: {
                                    fontSize: '11px',
                                },
                            },
                        },
                    },
                },
                '& .checkboxes-filter, & .tags-filter': {
                    boxShadow: 'none !important',
                    '&.open': {
                        overflow: 'visible !important',
                        maxHeight: '384px',
                        [`@media (max-width: ${breakpoints.values.md}px)`]: {
                            maxHeight: '484px',
                        },
                        '& .MuiSvgIcon-root.MuiChip-deleteIcon': {
                            display: 'block !important',
                        },
                    },
                    '& .MuiFormControl-root': {
                        paddingRight: 0,
                        '&::before': {
                            right: '21px',
                            width: '20px',
                            background: 'linear-gradient(to right, rgba(255,255,255, 0.1),rgba(255,255,255, 0.9) ,rgba(255,255,255)) !important',
                        },
                        '&::after': {
                            width: '20px',
                            background: 'linear-gradient(to right, rgba(255,255,255, 0.1),rgba(255,255,255, 0.9) ,rgba(255,255,255)) !important',
                        },
                    },
                    '& .MuiInputBase-root.MuiOutlinedInput-root': {
                        minWidth: '200px !important',
                        padding: '10px 14px !important',
                    },
                    '& .checkboxes-filter__popup.open, & .tags-filter__popup.open': {
                        position: 'relative',
                        padding: '0 10px',
                        boxShadow: `${Palette.boxShadow.elevation16} !important`,
                        '& .select-all': {
                            margin: '0',
                            padding: '10px 8px',
                        },
                    },
                    '& .checkboxes-filter__popup__checkboxes': {
                        maxHeight: '288px !important',
                        '& .MuiFormControl-root': {
                            maxHeight: '288px !important',
                            padding: '10px 0 !important',
                            overflow: 'scroll',
                        },
                    },
                },
                '& .MuiInputBase-root.MuiOutlinedInput-root': {
                    padding: '10px 16px !important',
                },
                '& .MuiFormControl-root': {
                    width: '100%',
                    maxWidth: '305px',
                    paddingRight: '0',
                },
                '& .MuiFormLabel-root.MuiInputLabel-root': {
                    backgroundColor: Palette.white,
                },
                '& .checkboxes-filter__input': {
                    boxShadow: 'none !important',
                    overflow: 'visible !important',
                },
                '& .RaFilterFormInput-spacer': {
                    display: 'none',
                },
                '& .range-picker': {
                    boxShadow: 'none !important',
                    '& .range-picker-label': {
                        backgroundColor: Palette.white,
                    },
                },
                '& .RaFilterFormInput-hideButton': {
                    display: 'none !important',
                },
                '& .radio-button-group': {
                    border: 'none',
                    padding: '0 8px',
                    '& .MuiFormLabel-root': {
                        textTransform: 'uppercase',
                        color: Palette.black,
                        paddingLeft: '20px',
                        fontWeight: '700',
                        fontSize: '10px',
                        transform: 'none',
                        marginBottom: '7px',
                    },
                    '& .MuiFormGroup-root[role="radiogroup"]': {
                        border: 'none',
                        display: 'block',
                        background: 'transparent',
                        '& .MuiFormControlLabel-root': {
                            border: 'none !important',
                            display: 'block',
                            padding: '6px 14px 6px 0px',
                        },
                        '& .MuiButtonBase-root.MuiRadio-root': {
                            '&::before': {
                                display: 'none',
                            },
                        },
                    },
                    '& .MuiRadio-root': {
                        '& span svg.MuiSvgIcon-root': {
                            width: '20px',
                            height: '20px',
                            fill: Palette.gray.gray300,
                        },
                        '&.Mui-checked span svg.MuiSvgIcon-root': {
                            backgroundPosition: 'center',
                            backgroundRepeat: 'no-repeat',
                            backgroundImage: `url("${RadioButtonCheckedIcon}")`,
                        },
                    },
                },
            },
        },
    },
    productRankingElement: {
        '&.product-ranking-element': {
            display: 'flex',
            alignItems: 'center',
            '& + .product-ranking-element, & + .notification-box': {
                marginTop: '8px',
            },
        },
        '& a': {
            display: 'flex',
            alignItems: 'center',
            gap: '16px',
            backgroundColor: Palette.gray.gray75,
            padding: '12px 32px 12px 12px',
            width: '100%',
            justifyContent: 'space-between',
            borderRadius: '16px',
            [`@media (max-width: ${breakpoints.values.md}px)`]: {
                padding: '12px 20px',
            },
            '&:hover': {
                backgroundColor: Palette.gray.gray100,
            },
            '& .product-ranking-image': {
                width: '56px',
                height: '56px',
                borderRadius: '8px',
                backgroundColor: Palette.white,
                overflow: 'hidden',
                [`@media (max-width: ${breakpoints.values.md}px)`]: {
                    display: 'none',
                },
                '&.no-image-icon': {
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    '& svg': {
                        width: '24px',
                        height: 'auto',
                    },
                },
                '& img': {
                    width: 'auto',
                    height: '56px',
                    objectFit: 'contain',
                    display: 'block',
                    margin: '0 auto',
                },
            },
            '& .product-ranking-name': {
                fontSize: '14px',
                fontWeight: '400',
                lineHeight: '20px',
                letterSpacing: '-0.14px',
                flex: 1,
                '& .ean-number': {
                    color: Palette.gray.gray500,
                    fontSize: '11px',
                    fontWeight: '400',
                    lineHeight: '16px',
                    letterSpacing: '-0.11px',
                    display: 'block',
                    [`@media (max-width: ${breakpoints.values.md}px)`]: {
                        marginTop: '2px',
                    },
                },
            },
            '& .product-ranking-percentage': {
                color: Palette.black,
                fontSize: '16px',
                fontWeight: '600',
                lineHeight: '22px',
                letterSpacing: '-0.16px',
            },
        },
    },
    filterLoading: {
        width: '100%',
        height: '70px',
        fontSize: '11px',
        textAlign: 'center',
        padding: '25px 0',
        '& span': {
            width: '20px !important',
            height: '20px !important',
            margin: '0 8px -5px -16px',
            '& .svg': {
                width: '20px',
                height: '20px',
            },
        },
    },
    arrayFilterAutocompleteInput: {
        fieldset: {
            boxShadow: 'none !important',
        },
        '& > .MuiFormControl-root': {
            '&::before, &::after': {
                content: '""',
                height: '100%',
                position: 'absolute',
                right: '34px',
                top: 0,
                background: `linear-gradient(90deg, rgba(247, 247, 247, 0.00) 0%, ${Palette.gray.gray75} 100%)`,
                zIndex: '3',
                pointerEvents: 'none',
            },
            '&::after': {
                right: 'auto',
                left: '0',
                width: '20px',
                transform: 'rotate(180deg)',
                borderRadius: '10px',
            },
            '&::before': {
                content: '""',
                width: '30px',
                height: '100%',
                position: 'absolute',
                right: '30px',
                top: 0,
                background: `linear-gradient(90deg, rgba(247, 247, 247, 0.00) 0%, ${Palette.gray.gray75} 100%)`,
                zIndex: '3',
                pointerEvents: 'none',
            },
        },
        '& .MuiAutocomplete-endAdornment': {
            display: 'none',
        },
        '& .MuiInputBase-root': {
            minWidth: '276px',
            flexWrap: 'unset',
            maxWidth: '530px',
            overflow: 'hidden',
            whiteSpace: 'nowrap',
            scrollbarWidth: 'none',
            cursor: 'auto',
            padding: '10px 16px 10px 14px !important',
            '& input[type="text"]': {
                minWidth: '0px',
                zIndex: '3',
                marginRight: '0 !important',
                marginLeft: '6px',
                transition: '0.2s ease',
                '&:focus': {
                    minWidth: '60px',
                },
            },
            '&::-webkit-scrollbar': {
                width: '0px',
                background: 'transparent',
            },
        },
        '& .MuiInputBase-root.MuiOutlinedInput-root': {
            width: '93%',
        },
    },
    customConfirmDialog: {
        '& .MuiPaper-root.MuiPaper-elevation': {
            borderRadius: '32px',
            boxShadow: Palette.boxShadow.elevation3,
        },
        '& .MuiDialogContent-root': {
            padding: '0 !important',
            maxWidth: '400px !important',
        },
        '& .MuiDialogActions-root, & .MuiTypography-root.MuiTypography-h6': {
            display: 'none',
        },
    },
    serviceForm: {
        '& .RaShow-noActions': {
            margin: '0',
        },
        '& .popup-wrapper-top': {
            padding: '32px 40px !important',
            [`@media (max-width: ${breakpoints.values.md}px)`]: {
                padding: '32px 20px !important',
            },
            '& .popup-box--header': {
                padding: 0,
            },
        },
        '& .popup-box--header': {
            alignItems: 'center',
        },
    },
    accessKeyForm: {
        '& .RaShow-noActions': {
            margin: '0',
        },
        '& .popup-wrapper-top': {
            padding: '32px 40px !important',
            [`@media (max-width: ${breakpoints.values.md}px)`]: {
                padding: '32px 20px !important',
            },
            '& .popup-box--header': {
                padding: 0,
            },
        },
        '& .popup-box--header': {
            // padding: '24px 56px 24px',
            alignItems: 'center',
        },
        '& .padding-wrapper': {
            '& .MuiCardContent-root': {
                marginBottom: '0 !important',
            },
        },
    },
};
